export default {
  ADD_ART: 'art/ADD_ART',
  ADD_TO_RECENTLY_USED_ART: 'art/ADD_TO_RECENTLY_USED_ART',
  BROWSED_CATEGORIES: 'art/BROWSED_CATEGORIES',
  CATEGORY: 'art/CATEGORY',
  CATEGORY_LOADED: 'art/CATEGORY_LOADED',
  CATEGORY_FAILED: 'art/CATEGORY_FAILED',
  CHANGE_SPOT_COLOR: 'art/CHANGE_SPOT_COLOR',
  CLEAR: 'art/CLEAR',
  CLIPART_AUTOFILL_DATA_LOADED: 'art/CLIPART_AUTOFILL_DATA_LOADED',
  LOADING_RESULTS: 'art/LOADING_RESULTS',
  ROOT: 'art/ROOT',
  ROOT_LOADED: 'art/ROOT_LOADED',
  ROOT_FAILED: 'art/ROOT_FAILED',
  SEARCH: 'art/SEARCH',
  SEARCH_LOADED: 'art/SEARCH_LOADED',
  SEARCH_FAILED: 'art/SEARCH_FAILED',
  SELECT_CLIPART: 'art/SELECT_CLIPART',
  SET_RECENTLY_USED_CLIPART: 'art/SET_RECENTLY_USED_CLIPART',
  SET_RECENTLY_USED_CLIPART_SNAPSHOT: 'art/SET_RECENTLY_USED_CLIPART_SNAPSHOT',
  SET_LAST_SEARCH: 'art/SET_LAST_SEARCH',
  SWAP: 'art/SWAP',
  UPDATE_LOCK_RATIO: 'art/UPDATE_LOCK_RATIO',
  UPDATE_ART_SEARCH_HISTORY: 'art/UPDATE_ART_SEARCH_HISTORY',
  UPDATE_TRANSPARENCY: 'art/UPDATE_TRANSPARENCY',
  UPDATE_LAST_ART: 'art/UPDATE_LAST_ART'
};
